import Service from "../../../api/api-service";
import { ApiUrl } from "../../../api/api-url";

const service = new Service();

export const GetListInvestmentProject = (filter = {}) => {
  const params = new URLSearchParams();
  Object.keys(filter).forEach((key) => {
    const value = filter[key];
    if (value !== undefined && value !== null && value !== "") {
      params.append(key, value);
    }
  });
  return service.get(ApiUrl.InvestmentProjectGetList, params);
};

export const GetDetailInvestmentProject = (id) =>
  service.get(ApiUrl.InvestmentProjectGetDetail, "id=" + id);

export const CreateInvestmentProject = (body) =>
  service.post(ApiUrl.InvestmentProjectCreate, body);

export const UpdateInvestmentProject = (id, body) =>
  service.postParams(ApiUrl.InvestmentProjectUpdate, "id=" + id, body);

export const DeleteInvestmentProject = (id) =>
  service.postParams(ApiUrl.InvestmentProjectDelete, "id=" + id);
